

import BroCodeDisplay from './BroCodeDisplay';
import BroCodeActions from './BroCodeActions';
import BroScoreOptimization from './BroScoreOptimization';
import { rewardTwitterShare, generateTwitterShareUrl } from '@/lib/broScore';
import { toast } from "sonner";

interface SocialBroContentProps {
  brocode: string;
  twitterHandle: string;
  onOpenRerollDialog: () => void;
  onOpenBrometheusDialog: () => void;
  twitterShareUrl: string;
  walletAddress: string;
}

const SocialBroContent = ({ 
  brocode, 
  twitterHandle,
  onOpenRerollDialog, 
  onOpenBrometheusDialog, 
  twitterShareUrl, 
  walletAddress 
}: SocialBroContentProps) => {
  
  // Handle Twitter share with proper error handling and feedback
  const handleTwitterShare = async () => {
    try {
      console.log('Attempting Twitter share reward for wallet:', walletAddress);
      
      const success = await rewardTwitterShare(walletAddress.toLowerCase());
      
      if (success) {
        console.log('Twitter share successful, +15 BroScore awarded');
        toast.success("+15 BroScore awarded for Twitter share!");
      } else {
        console.log('Twitter share already completed for this wallet');
      }
    } catch (error) {
      console.error('Error during Twitter share reward:', error);
      toast.error("Failed to process Twitter share reward");
    }
    
    // Generate the correct Twitter share URL
    const correctTwitterUrl = generateTwitterShareUrl(brocode);
    window.open(correctTwitterUrl, "_blank");
  };

  const handleTelegramClick = () => {
    window.open("https://t.me/BroRankBot", "_blank");
  };

  return (
    <div className="space-y-4 mt-16 text-center">
      <div className="mb-6 flex justify-center">
        <div className="inline-block bg-secondary rounded-full p-3 shadow-inner">
          <img 
            src="/lovable-uploads/clr_4.png" 
            alt="Bromentum Logo" 
            className="w-10 h-10 object-contain"
          />
        </div>
      </div>
      
      <p className="text-lg text-tan">Welcome to the social brotherhood, Social Bro!</p>
      <p className="text-lg text-tan">You've earned +35 BroScore through social engagement!</p>
      
      <BroCodeDisplay brocode={brocode} twitterHandle={twitterHandle} />
      
      <div className="mt-6 p-4 bg-navy-light rounded-lg border border-tan-dark max-w-md mx-auto">
        <p className="text-sm text-tan">
          <strong>Social Bro Benefits:</strong> Full airdrop eligibility and enhanced social features!
        </p>
      </div>
      
      <BroCodeActions 
        openRerollDialog={onOpenRerollDialog}
        openBrometheusDialog={onOpenBrometheusDialog}
        twitterShareUrl={twitterShareUrl}
        walletAddress={walletAddress}
        isShadowBro={false}
        onClickTelegram={handleTelegramClick}
        onClickTwitter={handleTwitterShare}
      />
      
      <BroScoreOptimization walletAddress={walletAddress} />
    </div>
  );
};

export default SocialBroContent;
